// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__3La4L","open":"App_open__1iLQT background_white__1bJ-V","closed":"App_closed__3yeW9 background_white__1bJ-V","main":"App_main__3ZkGI"};